import React from "react";

export default function Project({ data }) {
  const { name, role, image, website, description } = data;

  return (
    <div className="project">
      <div className="project__image-wrapper">
        <img src={image} alt={name} className="project__image" />
        <img src={image} alt={name} className="project__image" />
      </div>

      <div className="project__info">
        <p className="project__title">Project: {name}</p>
        <p className="project__role">Role: {role}</p>
        <p className="project__website">
          Website:{" "}
          <a
            className="project__website__link"
            target="_blank"
            rel="noopener noreferrer"
            href={website}
          >
            {website}
          </a>
        </p>
        {description}
      </div>
    </div>
  );
}
